import * as React from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

export default function BBCodeCopyAlert(props) {
    return(
        <Collapse in={props.open}>
            <div style={{padding: 10}}></div>
            <Alert severity="success" action={
                <IconButton aria-label="close" color="inherit" size="small" onClick={() => { props.setBBCodeCopyAlertOpen(false) }}>
                <CloseIcon fontSize="inherit" />
                </IconButton>
            } sx={{ mb: 2 }}>
                Template BBCode copied to clipboard.
            </Alert>
        </Collapse>
    );
}
